import DuckEntity from './DuckEntity';
import { apiAction, apiFetch } from 'utils';

const baseDuck = new DuckEntity('counselorAssignments');

baseDuck.actions.manage = (data) => apiAction(
  baseDuck.types.SAVE_BEGIN, baseDuck.types.SAVE_SUCCESS, baseDuck.types.SAVE_ERROR,
  (state) => apiFetch.put(state, `${baseDuck.config.apiPath}`, data),
  data,
  { counselor_assignment: baseDuck.schema }
);

baseDuck.actions.getAssignedCounselors = (contactIds) => apiAction(
  baseDuck.types.GET_BEGIN, baseDuck.types.GET_SUCCESS, baseDuck.types.GET_ERROR,
  (state) => apiFetch.get(state, `${baseDuck.config.apiPath}/assigned_counselors?contact_ids=${contactIds.join(',')}`)
);

export const counselorAssignments = baseDuck;
export default baseDuck.reducer;
